export default __webpack_public_path__ + "static/media/home__about--map.d5a5de18.png";